<template>
    <div class="sub-title">
        <h2>{{title}}</h2>
    </div>
</template>

<script>
export default{
    data() {
        return {
            title: ''
        }
    },
    watch: {
        $route(to, from){
            if(to.path !== from.path){
                this.title = '';
                this.getDepth();
            }
        }
    },
    methods: {
        getDepth() {
            const route = this.$route.path;           
        }
    },
    created() {
        this.getDepth();
    }
}
</script>